import React from "react";
import { Link } from 'react-router-dom';
import './App.css';

const Landing = () => {
    return (
        <div className="landing-page">
            <div>
                <img src="lock_logo.png" alt="logo" className="logo_img" />
                <h1><strong>Pneumatic Protocol</strong></h1>
                <h5>Pneumatic Protocol is an innovative, smart contract based solution <br/> for whitelisting crypto treasury interactions.</h5>
                <br></br>
                <br></br>
                <button id="get-started-button">
                    <Link id="launch-link" to="/app">Launch the App</Link>
                </button>
            </div>
        </div>
    )
}

export default Landing;
